import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILeadStage, ILeadStageState } from "./leadStageModel";
import {
  ActiveInactiveLeadStage,
  createLeadStage,
  deleteLeadStage,
  getAllActiveLeadStage,
  getAllLeadStage,
  getLeadStageByID,
  updateLeadStage,
} from "./services/leadStage.services";

const initialState: ILeadStageState = {
  loading: false,
  formLoading: false,
  error: "",
  LeadStageList: [],
  LeadStageID: null,
  LeadStageDetail: {
    LeadStage: "",
    LeadStageType: "",
    IsActive: 1,
  },
};

const LeadStageSlice = createSlice({
  name: "leadStage",
  initialState,
  reducers: {
    clearLeadStageDetails: (state) => {
      state.LeadStageDetail = initialState.LeadStageDetail;
    },
    setLeadStageID: (state, action) => {
      state.LeadStageID = action.payload;
    },
    clearLeadStageID: (state) => {
      state.LeadStageID = initialState.LeadStageID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllLeadStage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllLeadStage.fulfilled,
      (state, action: PayloadAction<ILeadStage[]>) => {
        state.loading = false;
        state.LeadStageList = action.payload || [];
      }
    );
    builder.addCase(getAllLeadStage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LeadStageList = [];
    });
    builder.addCase(getAllActiveLeadStage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveLeadStage.fulfilled,
      (state, action: PayloadAction<ILeadStage[]>) => {
        state.loading = false;
        state.LeadStageList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveLeadStage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LeadStageList = [];
    });
    builder.addCase(createLeadStage.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createLeadStage.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createLeadStage.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateLeadStage.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateLeadStage.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateLeadStage.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteLeadStage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteLeadStage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteLeadStage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(ActiveInactiveLeadStage.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveLeadStage.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveLeadStage.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getLeadStageByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getLeadStageByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.LeadStageDetail = action.payload;
    });
    builder.addCase(getLeadStageByID.rejected, (state, action) => {
      state.formLoading = false;
      state.LeadStageDetail = initialState.LeadStageDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearLeadStageDetails, setLeadStageID, clearLeadStageID } =
  LeadStageSlice.actions;
export default LeadStageSlice.reducer;
